// extracted by mini-css-extract-plugin
export default {"ramen":"Landing_ramen__6+9gO","landing":"Landing_landing__diPeG"};